import questionsSolution from "../data/questionsSolution";
import { mainText } from "../../index";

function displayQuestion(nbr = 1) {
  mainText.textContent = questionsSolution[nbr-1].question;
};

export default displayQuestion;